/* global mapboxgl */

(() => {

  const canvas = document.getElementById('map');
  const feed = document.getElementById('map-feed');
  const token = 'pk.eyJ1IjoiY2FiaW5ldGMiLCJhIjoiY2t0dmdqbjM1MjlzNDJubXAzZnlnaHA5byJ9.KYt36hn52cZArS_E-XoHcQ';

  if (!canvas || !feed || !token) { return; }

  mapboxgl.accessToken = `${token}`;

  const lat = `${canvas.dataset.mapLat}`;
  const lng = `${canvas.dataset.mapLng}`;
  const style = 'mapbox://styles/cabinetc/cku6x215d3zm617nzhndo3iul';
  const zoom = `${canvas.dataset.mapZoom}`;

  const center = [
    parseFloat(lng),
    parseFloat(lat)
  ];

  if (!center || !lat || !lng || !style || !zoom) { return; }

  fetch(feed.value)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.json();
    })
    .then((response) => {

      let points = response.data;

      if (!points) { return; }

      const map = new mapboxgl.Map({
        center: center,
        container: canvas,
        interactive: false,
        maxZoom: 16,
        style: style,
        zoom: zoom
      });

      /**
       *
       */

      map.on('load', () => {
        addMapSource(points);
        addMapMarker(points[0]);
        addNavigationControl();
      });

      /**
       *
       */

      const addMapSource = (points) => {
        map.addSource('locations', {
          type: 'geojson',
          data: {
            "type": "FeatureCollection",
            "features": points
          }
        });
      }

      const addMapMarker = (point) => {
        let marker = addElement('#location-marker', point.properties);
        let popup = addElement('#location-popup', point.properties);
        let params = {
          anchor: 'bottom',
          closeButton: false,
          closeOnClick: false,
          focusAfterOpen: false,
          maxWidth: 0,
          offset: 20
        }

        popup = trimElementNode(popup, 'span[class="url"]');

        new mapboxgl.Marker(marker)
          .setLngLat(point.geometry.coordinates)
          .setPopup(new mapboxgl.Popup(params).setHTML(popup.outerHTML))
          .addTo(map)
          .togglePopup();
      }

      /**
       *
       */

      const addNavigationControl = () => {
        map.addControl(
          new mapboxgl.NavigationControl(),
          'bottom-right'
        );
      }

      /**
       *
       */

      const addElement = (selector, properties = []) => {
        let template = document.querySelector(selector);
        let el = document.createElement('div');
        el.innerHTML = template.innerHTML.trim();
        el.innerHTML = populateElement(el.innerHTML, properties);
        return el.firstChild;
      }

      const populateElement = (str, properties) => {
        Object.entries(properties).forEach(prop => {
          let key = prop[0];
          let val = prop[1] ?? '';
          str = str.replaceAll('[' + key + ']', val);
        });
        return str;
      }

      const trimElementNode = (el, selector) => {
        let node = el.querySelector(selector);
        if (node) {
          el.removeChild(node);
        }

        return el;
      }
    })
    .catch((error) => {
      console.log(error);
    });
})()
